const dateDisplay = (value) =>
  value && new Date(value).toLocaleDateString('en-IN');
export default dateDisplay;
